<template>
    <div class="volet_bas">

        <div id="volet_bas-banner" data-state="close">
            <div id="banner-title" @click="toggleMobileMenu()"><div>ARCHITECTURE ET PRÉCARITÉS</div> <span v-if="$mq == 'mobile'" id="mobile-toggler"><svg id="menu-mobile-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.12 73.85" class="fleche_ferme"><path d="m24.06 73.85 24.06-21.26-4.41-4.75-15.95 14.47V0h-7.34v62.31L4.48 47.84 0 52.59l24.06 21.26z"></path></svg></span></div>
            <div id="banner-text" class="ellipsis"><p>Les réponses architecturales,<br>urbaines et paysagères aux enjeux<br>de précarité en France et ailleurs</p></div>
            <div id="banner-links">
                <ul>
                    <li class="section-button ellipsis gc1" @click="mode = 'actualites'" v-on:mousedown="changeFooterMode" :class="mode == 'actualites' ? 'menu_actif' : ''" data-mode="actualites">Actualités</li>
                    <li class="section-button ellipsis gc1" @click="mode = 'equipe'" v-on:mousedown="changeFooterMode" :class="mode == 'equipe' ? 'menu_actif' : ''" data-mode="equipe">&Eacute;quipe</li>
                    <li class="section-button ellipsis gc1" @click="mode = 'projet'" v-on:mousedown="changeFooterMode" :class="mode == 'projet' ? 'menu_actif' : ''" data-mode="projet">Le projet</li>
                    <li class="section-button ellipsis gc1" @click="mode = 'ressources'" v-on:mousedown="changeFooterMode" :class="mode == 'ressources' ? 'menu_actif' : ''" data-mode="ressources">Références</li>
                    <li class="section-button ellipsis gc2" @click="mode = 'enrichir'" v-on:mousedown="changeFooterMode" :class="mode == 'enrichir' ? 'menu_actif' : ''" data-mode="enrichir">Contribuer</li>
                    <li v-if="$mq == 'mobile'" class="section-button gc2">
                        <input type="text" placeholder="Rechercher" value="" v-model="valeur_recherche" v-on:keyup.enter="rechercher()" class="input-text">
                    </li>
                </ul>
            </div>
            <div id="banner-search-box" v-on:keyup.enter="rechercher()">
                <input type="text" placeholder="Rechercher" value="" v-model="valeur_recherche" class="input-text">
                <!-- <button id="search-hit" class="icone_recherche" @click="rechercher()"></button> -->
            </div>
        </div>

        <div id="volet_bas-section-wrapper">
            <v-projet v-if="mode == 'projet'"></v-projet>
            <v-equipe v-if="mode == 'equipe'"></v-equipe>
            <v-enrichir v-if="mode == 'enrichir'"></v-enrichir>
            <v-ressources v-if="mode == 'ressources'"></v-ressources>
            <v-actualites v-if="mode == 'actualites'"></v-actualites>
            <v-resultats-recherche v-if="mode == 'resultats'" v-bind:resultats="resultats"></v-resultats-recherche>
        </div>

        <div
            id="overlay"
            class="open"
            @click="fermerOverlay"
            @mouseenter="showCloser"
            @mousemove="moveCloser"
            @mouseleave="hideCloser"
        >
            <div><!-- <div id="overlay-closer" @click="fermerOverlay">✕</div> --><p><i>Architecture et précarités</i> est une plateforme de recherche qui indexe plus de 200 projets interrogeant les enjeux de précarité de part le monde et à laquelle chacun·e peut <u id="link-enrichir" v-on:click="openEnrichir(), mode = 'enrichir'">contribuer</u>.</p></div>
            <span id="overlay-closer-mobilum">✕</span>
        </div>

    <!-- KD + EG -->
        <!-- TITRE -->
        <!-- <div class="titre" @click="toggle_menu_mobile()">
            <template v-if="survol_intro && $mq != 'mobile'">
                ARCHITECTURE<br>ET PRÉCARITÉS 
            </template>
            <template v-else>
                ARCHITECTURE ET PRÉCARITÉS 
            </template>
        </div> -->

        <!-- FLECHE_MENU_MOBILE -->
        <!-- <svg v-if="$mq === 'mobile'" :class="survol_intro ? 'fleche_ouvert' : 'fleche_ferme'" id="menu-mobile-arrow" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48.12 73.85">
            <path d="m24.06 73.85 24.06-21.26-4.41-4.75-15.95 14.47V0h-7.34v62.31L4.48 47.84 0 52.59l24.06 21.26z"></path>    
        </svg> -->

        <!-- MENU -->
        <!-- <div class="menu">
            <div class="champ_recherche" @mouseover="survol_recherche = true; opacite_intro = 0" @mouseout="survol_recherche = false; opacite_intro = 1" v-on:keyup.enter="rechercher()">
                <input type="text" v-model="valeur_recherche" size="10" v-if="survol_recherche">
                <div class="icone_recherche" @click="rechercher()"></div>
            </div>
            <div @click="mode = 'projet'" :class="mode == 'projet' ? 'menu_actif' : ''" >LE PROJET</div>
            <div @click="mode = 'equipe'" :class="mode == 'equipe' ? 'menu_actif' : ''" >L’ÉQUIPE</div>
            <div @click="mode = 'enrichir'" :class="mode == 'enrichir' ? 'menu_actif' : ''" >ENRICHIR LA BASE DE DONNÉES</div>
            <div @click="mode = 'ressources'" :class="mode == 'ressources' ? 'menu_actif' : ''" >RÉFÉRENCES</div>
        </div> -->

        <!-- AFFICHAGE CONTENUS -->
        <!-- <div v-if="mode == 'intro'" class="contenu_volet_bas" v-html="contenu_intro" :style="{opacity: changer_opacite_desktop()}">
        </div>

        <v-resultats-recherche v-else-if="mode == 'resultats'" v-bind:resultats="resultats" :style="{opacity: changer_opacite_desktop()}">
        </v-resultats-recherche>

        <v-projet v-else-if="mode == 'projet'" :style="{opacity: changer_opacite_desktop()}">
        </v-projet>

        <v-equipe v-else-if="mode == 'equipe'" :style="{opacity: changer_opacite_desktop()}">
        </v-equipe>

        <v-enrichir v-else-if="mode == 'enrichir'" :style="{opacity: changer_opacite_desktop()}">
        </v-enrichir>

        <v-ressources v-else-if="mode == 'ressources'" :style="{opacity: changer_opacite_desktop()}">
        </v-ressources> -->
    </div>
</template>

<script>

import { state } from '../main.js';
import { url_annexes, url_base } from '../variables.js';

import Projet from './Bas/Projet.vue';
import Equipe from './Bas/Equipe.vue';
import Enrichir from './Bas/Enrichir.vue';
import Ressources from './Bas/Ressources.vue';
import Actualites from './Bas/Actualites.vue';
import ResultatsRecherche from './Bas/ResultatsRecherche.vue';

export default {
    data() {
        return {
            mode: state.mode,
            valeur_recherche: "",
            contenu_intro: "",
            opacite_intro: 0,
            survol_intro: false,
            survol_recherche: false,
            resultats: []
        }
    },

    components: {
        'v-resultats-recherche': ResultatsRecherche,
        'v-projet': Projet,
        'v-equipe': Equipe,
        'v-enrichir': Enrichir,
        'v-ressources': Ressources,
        'v-actualites': Actualites
    },
    created: function() {
        //this.chercher_intro();
        document.body.setAttribute("data-footer",false);
    },
    methods: {
        changeFooterMode(e){
            var prevmode = document.body.getAttribute("data-mode");
            var nextmode = e.target.getAttribute("data-mode");
            if(prevmode == nextmode){
                console.log("CLOSE");
                document.body.setAttribute("data-footer",false);
                document.body.setAttribute("data-mode","");
                setTimeout(function(){
                    document.getElementById("volet_bas-banner").setAttribute("data-state","close");
                },100);
            }else{
                document.body.setAttribute("data-footer",true);
                document.body.setAttribute("data-mode",e.target.getAttribute("data-mode"));
                setTimeout(function(){
                    document.getElementById("volet_bas-banner").setAttribute("data-state","close");
                },100);
            }
        },
        chercher_intro() {
            /*this.axios.get(url_annexes+"introduction").then((response) => {
                this.contenu_intro = response.data.contenu;
            });*/
            this.contenu_intro = "Les réponses architecturales, urbaines et paysagères aux enjeux de précarité en France et ailleurs.";
        },
        rechercher() {
            //console.log(this.valeur_recherche);
            if(this.valeur_recherche.length > 2) {
                document.body.setAttribute("data-footer",true);
                setTimeout(function(){
                    document.getElementById("volet_bas-banner").setAttribute("data-state","close");
                },100);
                this.axios.get(url_annexes+"recherche/?q="+this.valeur_recherche).then((response) => {
                    this.mode = "resultats";
                    this.resultats = response.data;
                    /*for(var a = 0; a < document.getElementsByClassName("input-text").length; ++a){
                        console.log(document.getElementsByClassName("input-text")[a]);
                        document.getElementsByClassName("input-text")[a].value = "";
                        document.getElementsByClassName("input-text")[a].reset();
                    }*/
                });
            }else {
                alert("Merci de rechercher un terme de plus de 3 caractères.")
            }
        },
        fermerOverlay(e) {
            var target = document.getElementById("overlay");
            var state = true;
            if(e.target.id && e.target.id == "overlay"){
                if(window.innerWidth <= 750){
                }else{
                    state = true;
                }
            }else{
                if(e.target.id == "overlay-closer" || e.target.tagName == "U" || e.target.id == "overlay-closer-mobilum"){
                    state = true;
                }else{
                    state = false;
                }
            }

            if(state == true){
                if (target.classList.contains("open")) {
                    target.classList.remove("open");
                    document.body.setAttribute("data-overlay","false");
                    if(window.innerWidth <= 750){ // case : mobile breakpoint
                        //interventions
                        var url_projets = url_base + "interventions";
                        this.$router.push(url_projets);
                    }
                }
            }
        },
        openEnrichir() {
            document.body.setAttribute("data-footer",true);
        },
        toggleMobileMenu(){
            var menu = document.getElementById("banner-title").parentElement;
            var state = menu.getAttribute("data-state");
            //console.log(menu,state);
            if(state == "close"){
                state = "open";
            }else if(state == "open"){
                state = "close";
            }
            menu.setAttribute("data-state",state);
        },
        showCloser(e){
            var x = e.clientX, y = e.clientY;
            document.getElementById("overlay-closer-mobilum").style.left = x + "px";
            document.getElementById("overlay-closer-mobilum").style.top = y + "px";
            document.getElementById("overlay-closer-mobilum").style.display = "block";
        },
        moveCloser(e){
            var x = e.clientX, y = e.clientY;
            document.getElementById("overlay-closer-mobilum").style.left = x + "px";
            document.getElementById("overlay-closer-mobilum").style.top = y + "px";
        },
        hideCloser(e){
            var x = e.clientX, y = e.clientY;
            document.getElementById("overlay-closer-mobilum").style.left = x + "px";
            document.getElementById("overlay-closer-mobilum").style.top = y + "px";
            document.getElementById("overlay-closer-mobilum").style.display = "none";
        },

        /*afficher_menu_desktop() {
            if (this.$mq != "mobile") {
                this.opacite_intro = 1;
                this.survol_intro = true;
            }
        },

        masquer_menu_desktop() {
            if (this.$mq != "mobile") {
                this.opacite_intro = 0;
                this.survol_intro = false;
            }
        },

        toggle_menu_mobile() {
            if (this.$mq === "mobile") {
                if (!this.survol_intro) {
                    this.survol_intro = true;
                } else {
                    this.survol_intro = false;
                    this.mode = 'intro';
                }
            }
        },

        changer_opacite_desktop() {
            if (this.$mq != "mobile") {
                return this.opacite_intro;
            } else {
                return 1;
            }
        },
        classe_menu() {
            var retour = "";

            if (this.survol_intro) {
                retour += "menu_ouvert ";
            } else {
                retour += "menu_ferme ";
            }

            if (this.mode == 'intro') {
                retour += 'mode_intro'
            } else {
                retour += 'mode_deplie'
            }

            return retour;
        }*/
    
    }
};


</script>

<style>

/*overlay*/
#overlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: transparent;
    z-index: 100;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    /*cursor: pointer;*/
    cursor: none;
}
#overlay-closer-mobilum{
    position: fixed;
    cursor: none;
    font-size: var(--corps-overlay);
    line-height: var(--interlignage-overlay);
}
#overlay > div{
    background-color: white;
    box-shadow: 0 0 0 2px black;
    padding: calc(var(--tbm)*3) calc(var(--lrm)*3);
    width: 60vw;
    max-width: 570px;
    font-size: var(--corps-overlay);
    line-height: var(--interlignage-overlay);
    /*transform: translateY(calc(var(--interlignage-overlay)*-2));*/
    z-index: 101;
}
#overlay{}
#overlay > div{
    cursor: default;
}
#overlay p{
    pointer-events: all;
}
#overlay u{
    pointer-events: all;
}
#overlay-closer{
    cursor: pointer;
    float: right;
    margin-top: calc(var(--interlignage-overlay)*-2.75);
    transform: translateX(calc(var(--interlignage-overlay)*2.5));
}
#overlay.open{}
#overlay:not(.open){
    display: none;
    pointer-events: none;
}

body[data-overlay="true"] .volet_bas #volet_bas-banner{
    display: none;
}
body[data-overlay="true"] .volet-overlay{
    display: block;
    pointer-events: all;
}
body[data-overlay="false"] .volet-overlay{
    display: none;
    pointer-events: none;
}
body[data-overlay="false"] #overlay{
    display: none;
}
.volet-overlay{
    position: absolute;
    top: 0;
    left: auto;
    height: 1000vh;
    width: 100%;
    z-index: ;
    background-color: rgba(0,0,0,0.4);
    z-index: 16;
    opacity: 0.9;
}
#chronologie .volet-overlay{ background-color: var(--couleur-chronologie); }
#mots_clefs .volet-overlay{ background-color: var(--couleur-mots-clefs); }
#localisations .volet-overlay{ background-color: var(--couleur-localisations); }
#interventions .volet-overlay{ background-color: var(--couleur-interventions); }
#acteurs .volet-overlay{ background-color: var(--couleur-acteurs); }

#link-enrichir{
    cursor: pointer;
}
/*volet bas*/
.ellipsis{
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.volet_bas{
    z-index: 17;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: auto;
    background-color: white;
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-start;
    align-items: flex-start;
    white-space: normal;
}
#volet_bas-banner{
    height: auto;
    background-color: white;
    display: flex;
    flex-direction: row;
    /*justify-content: flex-start;*/
   /* align-items: flex-start;*/
    width: 100%;
    border-top: 2px solid black;
}

#volet_bas-banner > div{
    width: 100%;
    padding: var(--tbm) var(--lrm);
    padding-top: 5px;
}
#banner-title{
    width: 600px;
}
#banner-text{
    flex-grow: 1;
}
#banner-text p{
    max-width: 400px;
    white-space: normal;
}
#banner-links{
    /*display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-end;*/
    max-width: 320px;
    margin-right: calc(39px /3);
}
#banner-links > ul{
    display: grid;
    grid-template-columns: repeat(2,50%);
    list-style: none;
}
#banner-search-box{
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-end;
    width: auto!important;
}
input[type=text]{
    /*margin-right: calc(var(--interlignage-courant));*/
    margin-right: 4px;
}
.icone_recherche {
    display:inline-block;
    width: calc(var(--interlignage-courant));
    height: calc(var(--interlignage-courant));
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center right;
    background-image: url("../assets/images/loupe.svg");
}
input[type=text]{
    height: calc(var(--interlignage-courant)*1);
    max-width: 200px;
    border-bottom: 1px solid black;
}
input[type=text]:hover{
    border-bottom: 1px solid black;
}

button#search-hit{
    height: calc(var(--interlignage-courant)*1);
    padding-left: calc(var(--interlignage-courant)*1);
    margin-right: calc(var(--interlignage-courant)*1);
    margin-right: calc(var(--interlignage-courant)*1);
    cursor: pointer;
}

/*contents*/
#volet_bas-section-wrapper{
    width: 100vw;
    max-height: calc(100vh - 39px - 39px - 39px);
    height: auto;
    background-color: white;
    display: none;
    overflow-y: scroll;
}
.section{}
.section-content{
    background-color: white;
    padding: var(--tbm) var(--lrm);
    padding-bottom: calc(39px*2);
    padding-top: 5px;
}
.section-content > div{}
.section-content-loaded{
    background-color: transparent;
    min-height: 10px;
}
#section-projet .section-content-loaded, #section-enrichir .section-content-loaded, #section-equipe .section-content-loaded{
    width: 100%;
    max-width: 720px;
}
.section-content-banner{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    padding-bottom: calc(39px/3);
    position: relatve;
    width: calc(100% - 0px);
}
/*exceptions*/
#section-actualites .section-content-loaded, #section-equipe .section-content-loaded, #section-projet .section-content-loaded, #section-enrichir .section-content-loaded{
    margin-top: calc(39px * -1.2 + 3px);
}
#section-ressources .text{
    margin-top: 10px;
}
/*.closer{
    margin-top: 5px;
    margin-right: 5px!important;
    text-align: right;
    cursor: pointer;
}*/


.section-content-banner > div:not(.fermer){
    width: 100%;
    margin-right: calc(39px/3);
    /*background-color: red;
    box-shadow: 0 0 0 1px black;*/
}
.section-content-banner > div:nth-child(1){
    margin-right: 0;
}

.section-content-banner > div.fermer{
    margin-right: calc(var(--lrm)/2);
}
.section-button{
    cursor: pointer;
}
.section-button:hover{
    text-decoration: underline;
}
body[data-footer=true] #volet_bas-section-wrapper{
    display: block;
    border-top: 2px solid black;
}
body:not([data-footer=true]) .volet_bas{
    border-top: none!important;
}
:root{
    --title-width-margin: 240px;
}
.section-content-banner > div:nth-child(1){
    min-width: var(--title-width-margin);
    max-width: var(--title-width-margin);
}
.section-content-loaded{
    margin-left: var(--title-width-margin);
    margin-right: calc(39px + 39px/2);
    padding-bottom: 10px;
}
.section-content-loaded > div{
    border-bottom: 10vh;
    padding-top: calc(1px);
    /*max-width: 720px;*/
}
.section-content-loaded > div{
    /*display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 1rem;*/
}
.section-content-loaded > div hr{
    background-color: none;
    margin-bottom: calc(var(--interlignage-courant) *1);
    margin-top: calc(var(--interlignage-courant) * -0.5);
}
.section-content-loaded p{
    margin-block-start:0px;
    margin-block-end:0px;
    /*margin:0 !important;
    padding:0 !important;*/
    margin-top: calc(var(--interlignage-courant) / 2);
}


/*font settings*/
#banner-title{
    font-size: var(--corps-titre);
    line-height: var(--interlignage-titre);;
}
.section-content-banner > div{
    vertical-align: baseline;
}
.section-content-banner > div:nth-child(1){
    font-size: var(--corps-titre);
    line-height: var(--interlignage-titre);;
}
.section-content-banner > div:nth-child(2):not(.tools):not(.text):not(.closer){
    display: none;
}
.section-content-banner > div.text{
    /*min-width: calc(41% - 39px);*/
    width: 100%;
    flex-grow: 1;
    margin-right: 39px;
}
.menu_actif{
    text-decoration: underline;
}
/*KD + EG*/
/*.volet_bas {
    position: absolute;
    z-index: 15;
    bottom:0px;
    left:0px;
    width:100vw;
    height:39px;
    background-color:white;
    border-top:1.5px solid black;
    transition: height 0.5s;
    padding-top:8px;
}

.volet_bas > .titre {
    line-height: 26px;
}

.mode_intro.menu_ouvert {
    height:150px;
}

.mode_deplie.menu_ouvert {
    height:70vh;
}

.mode_deplie.mode_ferme {
    height:39px !important;
}

.contenu_volet_bas {
    position: absolute;
    white-space: normal;
    top:0px;
    padding-top:11px;
    bottom:0px;
    width:calc(100vw - 950px);
    max-width:700px;
    left:250px;
    transition: opacity 0.5s;
    z-index:3;
    overflow: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
}

.contenu_volet_bas::-webkit-scrollbar,
.contenu_volet_bas::-webkit-scrollbar {
  display: none;
}


.mode_intro .contenu_volet_bas {
    width:300px;
}

.menu {
    position: absolute;
    top:12px;
    right:12px;
    text-align:right;
    width:auto;
    z-index:5;
    user-select: none;
}

.menu > div {
    display:inline-block;
    margin-left:40px;
    cursor:pointer;
    vertical-align: top;
    line-height:12px;
    padding-top:2px;
}

.menu > div:not(.champ_recherche):hover,
.menu_actif {
    border-bottom:1.5px solid black;
}

.champ_recherche {
    position: relative;
    margin-top:-6px;
    width:auto;
    white-space: nowrap;
    padding:10px;
    padding-right:20px;
    vertical-align: top;
    background-color: white;
}

.icone_recherche {
    display:inline-block;
    padding-top:10px;
    width: 18px;
    height: 18px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center right;
    background-image: url("../assets/images/loupe.svg");
}

.champ_recherche > input {
    display:inline-block;
    border:none;
    border-bottom:1.5px solid black;
    width:150px;
    margin-right:10px;
    vertical-align: top;
    margin-top:0px;
}

.contenu_volet_bas p {
    -webkit-margin-after: 1em;
    margin-block-end: 1em; 
    margin-bottom: 1em !important;
}*/

/*.validation_recherche {
    padding:0px;
    margin:0px;
    cursor:pointer;
    margin-left:10px;
    margin-right:20px;
    padding-top:6px;
    padding-bottom:3px;
    padding-left:8px;
    padding-right:8px;
    border:1.5px solid black;

}*/
/*.champ_recherche {
    position: absolute;
    border:1px solid red;
}*/

</style>